//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "staffentryeduinfo",
     props:{
        //业务数据
        record:{type:Object,default: () => ({})},
        //流程数据
        process:{type:Object,default: () => ({})},
        //规则绑定
        rules:{type: Object,default: () => ({})},
        //自定义的参数
        config: {type: Object, default: () => ({})},
    },
    data(){
        return{
          //学历
          edubackgrounpList:[],
        }
    },
    methods:{
         /**
         * 初始化下拉框
         */
        initSelect(){
          let p_edubackgrounp = {
              showcode:'edubackgrounpList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"EDUBACKGROUNP","paras1":"1"}
          };
          let params = [];
          params.push(p_edubackgrounp);
          if(this.isNotNullOrEmpty(this.config.dropUrl)){
            this.initDropDownWithUrl(this,params,this.config.dropUrl);
          }else{
            this.initDropDown(this,params);
          }
        },
        /**
         * 入学日期不能早于
         */
        async checkedutime(){
          var len = this.record.staffedurow.length;
          var flag = true;
          for(let i = 0 ; i < len; i++ ){
            if(this.record.staffedurow[i].edubegintime !=null && this.record.staffedurow[i].edubegintime != ''
              && this.record.staffedurow[i].eduendtime !=null && this.record.staffedurow[i].eduendtime != ''){
                  let begintime = this.forMatDate(this.record.staffedurow[i].edubegintime);
                  let endtime = this.forMatDate(this.record.staffedurow[i].eduendtime);  
                  if (begintime > endtime) {
                    flag = false
                  }
            }
          }
          return flag;
        }
    },
    created() {
        this.initSelect();
    },
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentryeduinfo.vue